<template>
    <div>
        <section class="text-block">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1">
                        <h1>Kontakt</h1>

                        <p>V případě dotazů je vám k dispozici organizátor této akce:</p>

                        <p>
                            Cool Ticketing s.r.o.<br>
                            IČ: 02387662<br>
                            třída Karla IV. 468/18<br>
                            500 02 Hradec Králové
                        </p>

                        <p>
                            Telefon: <a href="tel:+420499599726">+420 499 599 726</a><br>
                            Email: <a href="mailto:turnaj@coolticket.cz">turnaj@coolticket.cz</a>
                        </p>
                    </v-col>
                </v-row>
            </v-container>
        </section>
    </div>
</template>

<script>
    export default {
        name: 'Contact',
    }
</script>
